import { handleActions } from "redux-actions";

import { setStatuses } from "./actions";

const initialState = {
    isLoadingStatuses: false,
    statuses: {},
    codes: []
};

export const statusReducer = handleActions(
    {
        [setStatuses]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);